// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"status_wrapper__bYN-w","DUPLICATE":"status_DUPLICATE__18ATe","CHECK_NEEDED":"status_CHECK_NEEDED__1XWf8","INVALID":"status_INVALID__aVVxz","VALID":"status_VALID__2A_QX"};